/**
 * 마법사 계통도 단계(2·3·4)의 배치 선언 — 세 단계와 DiagramPane 이 이 값만 본다. 단계를 넘길 때 그림의 크기·자리가
 * 같으려면 행·오른쪽 열·각주 칸의 치수가 한 곳에 있어야 한다.
 */

/** 마법사 오른쪽 열의 폭 — 그림이 가져가는 몫의 기준(둘이 같은 값을 보게 여기 둔다) */
export const WIZARD_SIDE_COLUMN_WIDTH = '22rem';
/** 그림 행 — 2·3·4단계가 같은 행 규칙을 쓴다: 넓은 창(md↑)은 «그림 | 오른쪽 열» 가로, 좁은 창은 세로 스택에 행 스크롤 */
export const WIZARD_DIAGRAM_ROW_SX = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: 2,
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
} as const;
/** 오른쪽 열 — 넓은 창은 고정 폭, 좁은 창은 전폭으로 그림 아래 */
export const WIZARD_SIDE_COLUMN_SX = {
  width: { xs: '100%', md: WIZARD_SIDE_COLUMN_WIDTH },
  flex: { xs: '0 0 auto', md: `0 0 ${WIZARD_SIDE_COLUMN_WIDTH}` },
  minWidth: 0,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
} as const;
/** 그림 아래 각주 칸의 높이 — 안내 한 줄 또는 파티션 범례 한 줄(제목+색 표)이 들어가는 크기; 넘치면 칸 안에서 스크롤 */
export const DIAGRAM_FOOTER_HEIGHT = '4rem';

